import React, { Fragment } from 'react';
import Link from 'components/link';
import Icon from 'components/icon';
import MenuLink from 'components/models/menu-link';
import PropTypes from 'prop-types';
import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import cn from 'classnames';
import stringHelper from 'js/string-helper';

const MainMenuItem = ({ id, link, isActive, items, number, className }) => {
  return (
    <AccordionItem className={cn('main-menu-item', className)} uuid={id}>
      <AccordionItemState>
        {({ expanded }) => (
          <Fragment>
            <div
              className={cn('main-menu-item__heading-holder', {
                'main-menu-item__heading-holder_expanded': expanded,
              })}
            >
              <a
                href={link.url}
                className={cn('main-menu-item__heading-link', {
                  'main-menu-item__heading-link_active': isActive,
                })}
              >
                {!isNaN(number) && (
                  <Fragment>
                    <span className="main-menu-item__heading-number">
                      {stringHelper.leadingZeroNumberFormat(number)}
                    </span>{' '}
                  </Fragment>
                )}
                <span className="main-menu-item__heading">{link.text}</span>
              </a>
              {items && items.length > 0 ? (
                <AccordionItemButton className="main-menu-item__trigger">
                  <Icon
                    name="chevron-down"
                    className="main-menu-item__trigger-icon"
                  />
                </AccordionItemButton>
              ) : null}
            </div>
            {items && items.length > 0 ? (
              <AccordionItemPanel>
                <ul className="main-menu-item__list">
                  {items.map((item, i) => (
                    <li
                      key={i}
                      className={cn('main-menu-item__list-item', {
                        'main-menu-item__list-item_active': item.isActive,
                      })}
                    >
                      <a
                        href={item.url}
                        className={cn('main-menu-item__list-link', {
                          'main-menu-item__list-link_active': item.isActive,
                        })}
                        target={item.openInNewTab ? '_blank' : null}
                        rel={
                          item.openInNewTab
                            ? 'nofollow noopener noreferrer'
                            : null
                        }
                      >
                        <span className="main-menu-item__list-link-text">
                          {item.text}
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </AccordionItemPanel>
            ) : null}
          </Fragment>
        )}
      </AccordionItemState>
    </AccordionItem>
  );
};

MainMenuItem.viewModelMeta = {
  className: 'ignore',
  id: 'ignore',
  number: 'int?',
};

MainMenuItem.propTypes = {
  className: PropTypes.string,
  number: PropTypes.number,
  id: PropTypes.number,
  isActive: PropTypes.bool,
  link: PropTypes.exact(Link.propTypes),
  items: PropTypes.arrayOf(PropTypes.exact(MenuLink.propTypes)).isRequired,
};

export default MainMenuItem;
